/* ================================================================
   Miresica cu Buget – clipul Save the Date ca apel, generat in browser

   Aceeasi secventa care se vede pe ecran (apelul, glisarea, aparitia
   datei) e desenata cadru cu cadru pe un <canvas> ascuns, apoi
   exportata ca video (MediaRecorder) sau ca GIF (gifenc, incarcat
   separat ca gifenc.min.js). Nimic nu pleaca de pe dispozitiv.

   Dimensiunile copiaza CSS-ul ecranului de apel, unde totul e masurat
   in unitati de container (cqw/cqh). Aici containerul e canvasul de
   1080x1920, deci 1cqw = 10.8px si 1cqh = 19.2px.

   Expune window.MiresicaApelClip = { pregatesteFundal, genereazaVideo,
   genereazaGif }. Folosit din miresica-ecran-apel.js.
   ================================================================ */

(function () {
  'use strict';

  var W = 1080;
  var H = 1920;

  /* Momentele secventei, in milisecunde. Glisarea e lasata intentionat
     lenta, ca ochiul sa o poata urmari in story, iar invitatia ramane
     apoi pe ecran destul cat sa fie citita fara graba. */
  var T_SLIDE_START = 1800;
  var T_SLIDE_END = 3400;
  var T_INVITATIE = 15000;
  var T_TOTAL = T_SLIDE_END + T_INVITATIE;
  /* Dupa acest moment nu se mai misca nimic: invitatia si-a terminat
     aparitia si sta pe loc. */
  var T_FINAL_MISCARE = T_SLIDE_END + 600;

  /* ---- Fundalul: poza statica sau GIF animat descompus in cadre ---- */

  /* ImageDecoder exista in Chrome si Edge; unde lipseste, GIF-ul animat
     ramane la primul cadru. */
  function pregatesteFundal(file) {
    if (file.type === 'image/gif' && 'ImageDecoder' in window) {
      return file
        .arrayBuffer()
        .then(function (date) {
          var decoder = new window.ImageDecoder({ data: date, type: 'image/gif' });
          return decoder.tracks.ready.then(function () {
            var pista = decoder.tracks.selectedTrack;
            var numar = Math.min((pista && pista.frameCount) || 1, 120);
            if (numar <= 1) {
              decoder.close();
              return null;
            }
            var cadre = [];
            var total = 0;
            var lant = Promise.resolve();
            for (var i = 0; i < numar; i++) {
              (function (idx) {
                lant = lant.then(function () {
                  return decoder.decode({ frameIndex: idx }).then(function (rezultat) {
                    /* duration e in microsecunde; fara durata, 100ms. */
                    var durata = rezultat.image.duration ? rezultat.image.duration / 1000 : 100;
                    return createImageBitmap(rezultat.image).then(function (bmp) {
                      rezultat.image.close();
                      cadre.push({ bmp: bmp, start: total, durata: durata });
                      total += durata;
                    });
                  });
                });
              })(i);
            }
            return lant.then(function () {
              decoder.close();
              return { tip: 'gif', cadre: cadre, total: total };
            });
          });
        })
        .catch(function () {
          return null;
        })
        .then(function (rezultat) {
          if (rezultat) return rezultat;
          return createImageBitmap(file).then(function (bmp) {
            return { tip: 'static', bmp: bmp };
          });
        });
    }
    return createImageBitmap(file).then(function (bmp) {
      return { tip: 'static', bmp: bmp };
    });
  }

  /* ---- Ajutoare de desen ------------------------------------------ */

  function easeInOut(x) {
    return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
  }

  function lerp(a, b, p) {
    return a + (b - a) * p;
  }

  /* Text cu spatiere intre litere, desenat caracter cu caracter, la fel
     ca in aplicatia de imagine. */
  function latimeTracked(ctx, text, tracking) {
    var total = 0;
    for (var i = 0; i < text.length; i++) {
      total += ctx.measureText(text[i]).width;
      if (i < text.length - 1) total += tracking;
    }
    return total;
  }

  function deseneazaTracked(ctx, text, cx, y, tracking) {
    if (!tracking) {
      ctx.fillText(text, cx, y);
      return;
    }
    var x = cx - latimeTracked(ctx, text, tracking) / 2;
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      ctx.fillText(ch, x + ctx.measureText(ch).width / 2, y);
      x += ctx.measureText(ch).width + tracking;
    }
  }

  /* Micsoreaza fontul pana cand randul incape in latimea disponibila. */
  function marimePotrivita(ctx, text, size, weight, font, trackingEm, maxLatime) {
    var s = size;
    while (s > 16) {
      ctx.font = weight + ' ' + s + 'px ' + font;
      if (latimeTracked(ctx, text, trackingEm * s) <= maxLatime) break;
      s -= 2;
    }
    return s;
  }

  /* Randurile mesajului, rupte pe cuvinte ca sa incapa in latimea data. */
  function rupeRanduri(ctx, text, maxLatime) {
    var randuri = [];
    text.split('\n').forEach(function (paragraf) {
      var cuvinte = paragraf.split(/\s+/).filter(Boolean);
      if (!cuvinte.length) return;
      var rand = cuvinte[0];
      for (var i = 1; i < cuvinte.length; i++) {
        if (ctx.measureText(rand + ' ' + cuvinte[i]).width <= maxLatime) {
          rand += ' ' + cuvinte[i];
        } else {
          randuri.push(rand);
          rand = cuvinte[i];
        }
      }
      randuri.push(rand);
    });
    return randuri;
  }

  function umbraText(ctx) {
    ctx.shadowColor = 'rgba(0, 0, 0, 0.55)';
    ctx.shadowBlur = 24;
    ctx.shadowOffsetY = 6;
  }

  function faraUmbra(ctx) {
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetY = 0;
  }

  /* Iconitele din SVG-urile paginii, desenate cu Path2D pe viewBox 24x24. */
  var ICON_CEAS_LINII = new Path2D('M12 9.5v3.7l2.4 1.4 M3.4 6.2l3-3 M20.6 6.2l-3-3');
  var ICON_MESAJ = new Path2D(
    'M20 4.5H4A1.5 1.5 0 0 0 2.5 6v9A1.5 1.5 0 0 0 4 16.5h2.5v3.6l4.3-3.6H20a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 20 4.5Z'
  );
  var ICON_TELEFON = new Path2D(
    'M6.5 4.5 10 8l-2 2a12 12 0 0 0 6 6l2-2 3.5 3.5-2.4 2.4c-6-.6-12.9-7.5-13.5-13.5L6.5 4.5Z'
  );

  function deseneazaIconita(ctx, path, fel, x, y, marime, culoare, siCerc) {
    ctx.save();
    ctx.translate(x, y);
    ctx.scale(marime / 24, marime / 24);
    ctx.strokeStyle = culoare;
    ctx.fillStyle = culoare;
    ctx.lineWidth = 1.7;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    if (siCerc) {
      ctx.beginPath();
      ctx.arc(12, 13, 7.5, 0, Math.PI * 2);
      ctx.stroke();
    }
    if (fel === 'stroke') ctx.stroke(path);
    else ctx.fill(path);
    ctx.restore();
  }

  /* ---- Fundalul ---------------------------------------------------- */

  function deseneazaFundal(ctx, t, fundal) {
    ctx.fillStyle = '#23281f';
    ctx.fillRect(0, 0, W, H);
    if (!fundal) return;

    var bmp;
    if (fundal.tip === 'gif') {
      var moment = t % fundal.total;
      var cadru = fundal.cadre[0];
      for (var i = 0; i < fundal.cadre.length; i++) {
        if (moment < fundal.cadre[i].start + fundal.cadre[i].durata) {
          cadru = fundal.cadre[i];
          break;
        }
      }
      bmp = cadru.bmp;
    } else {
      bmp = fundal.bmp;
    }

    /* Cover: poza umple cadrul, centrata, la fel ca object-fit: cover. */
    var scara = Math.max(W / bmp.width, H / bmp.height);
    var lat = bmp.width * scara;
    var inalt = bmp.height * scara;
    ctx.drawImage(bmp, (W - lat) / 2, (H - inalt) / 2, lat, inalt);

    /* Valul care tine textul lizibil, cu opririle din CSS. */
    var grad = ctx.createLinearGradient(0, 0, 0, H);
    grad.addColorStop(0, 'rgba(0,0,0,0.5)');
    grad.addColorStop(0.3, 'rgba(0,0,0,0.12)');
    grad.addColorStop(0.55, 'rgba(0,0,0,0.18)');
    grad.addColorStop(1, 'rgba(0,0,0,0.7)');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, W, H);
  }

  /* ---- Cele doua ecrane -------------------------------------------- */

  var PAD_SUS = 134; /* 7cqh */
  var PAD_LAT = 65; /* 6cqw */
  var PAD_JOS = 115; /* 6cqh */
  var MAX_LATIME = W - PAD_LAT * 2;

  function deseneazaNumeSus(ctx, o, marimeBaza) {
    var nume = o.nume.toUpperCase();
    if (!nume) return PAD_SUS;
    var size = marimePotrivita(ctx, nume, marimeBaza * o.scale.nume, 400, o.font, 0.3, MAX_LATIME);
    ctx.font = '400 ' + size + 'px ' + o.font;
    ctx.fillStyle = o.culoare;
    umbraText(ctx);
    var baza = PAD_SUS + size;
    deseneazaTracked(ctx, nume, W / 2, baza, 0.3 * size);
    faraUmbra(ctx);
    return baza;
  }

  function deseneazaEcranApel(ctx, t, o) {
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';

    /* Sus: numele si "mobil". */
    var bazaNume = deseneazaNumeSus(ctx, o, 58);
    if (o.nume) {
      ctx.font = '400 37px ' + o.font;
      ctx.fillStyle = o.culoare;
      ctx.globalAlpha = 0.85;
      umbraText(ctx);
      deseneazaTracked(ctx, 'mobil', W / 2, bazaNume + 22 + 37, 0.16 * 37);
      faraUmbra(ctx);
      ctx.globalAlpha = 1;
    }

    /* Jos: glisorul. */
    var pistaW = MAX_LATIME;
    var pistaH = 205; /* 19cqw */
    var pistaY = H - PAD_JOS - pistaH;

    /* Reamintire si Mesaj, deasupra pistei. */
    var icon = 86; /* 8cqw */
    var eticheta = 35; /* 3.2cqw */
    var bazaEticheta = pistaY - 77; /* gap 4cqh */
    var iconY = bazaEticheta - eticheta - 22 - icon;
    ctx.globalAlpha = 0.9;
    ctx.font = '400 ' + eticheta + 'px ' + o.font;
    ctx.fillStyle = o.culoare;
    umbraText(ctx);
    ctx.fillText('Reamintire', W * 0.3, bazaEticheta);
    ctx.fillText('Mesaj', W * 0.7, bazaEticheta);
    faraUmbra(ctx);
    deseneazaIconita(ctx, ICON_CEAS_LINII, 'stroke', W * 0.3 - icon / 2, iconY, icon, o.culoare, true);
    deseneazaIconita(ctx, ICON_MESAJ, 'stroke', W * 0.7 - icon / 2, iconY, icon, o.culoare, false);
    ctx.globalAlpha = 1;

    /* Pista. */
    ctx.fillStyle = 'rgba(255, 255, 255, 0.2)';
    ctx.beginPath();
    ctx.roundRect(PAD_LAT, pistaY, pistaW, pistaH, pistaH / 2);
    ctx.fill();

    /* Textul "raspundeti" pulseaza, ca pe pagina. */
    var puls = 0.55 + 0.45 * (0.5 + 0.5 * Math.sin((2 * Math.PI * t) / 2400 - Math.PI / 2));
    ctx.globalAlpha = puls;
    ctx.font = '400 43px ' + o.font;
    ctx.fillStyle = o.culoare;
    ctx.fillText('răspunde', W / 2, pistaY + pistaH / 2 + 15);
    ctx.globalAlpha = 1;

    /* Butonul verde, care gliseaza singur spre dreapta. */
    var raza = (pistaH - 32) / 2;
    var cx0 = PAD_LAT + 16 + raza;
    var cx1 = PAD_LAT + pistaW - 16 - raza;
    var progres =
      t < T_SLIDE_START ? 0 : easeInOut(Math.min(1, (t - T_SLIDE_START) / (T_SLIDE_END - T_SLIDE_START)));
    var cx = lerp(cx0, cx1, progres);
    var cy = pistaY + pistaH / 2;
    ctx.fillStyle = '#9ab49f';
    ctx.beginPath();
    ctx.arc(cx, cy, raza, 0, Math.PI * 2);
    ctx.fill();
    var telefon = raza * 0.9;
    deseneazaIconita(ctx, ICON_TELEFON, 'fill', cx - telefon / 2, cy - telefon / 2, telefon, '#ffffff', false);
  }

  function deseneazaEcranInvitatie(ctx, t, o) {
    /* Apare ca in CSS: se ridica putin si se limpezeste in jumatate de secunda. */
    var p = Math.min(1, (t - T_SLIDE_END) / 500);
    ctx.save();
    ctx.globalAlpha = p;
    ctx.translate(0, 30 * (1 - p));
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';

    var bazaNume = deseneazaNumeSus(ctx, o, 54);

    /* Grupul data + mesaj, centrat in spatiul ramas sub nume. */
    var marimeData = o.data ? marimePotrivita(ctx, o.data, 97 * o.scale.data, 600, o.font, 0.01, MAX_LATIME) : 0;

    var marimeMesaj = 65 * o.scale.mesaj;
    ctx.font = '400 ' + marimeMesaj + 'px ' + o.font;
    var randuriMesaj = o.mesaj ? rupeRanduri(ctx, o.mesaj, W * 0.8) : [];
    var inaltimeMesaj = randuriMesaj.length * marimeMesaj * 1.6;

    var gol = 58; /* 3cqh */
    var totalGrup = marimeData;
    if (randuriMesaj.length) totalGrup += (marimeData ? gol : 0) + inaltimeMesaj;

    var sus = bazaNume + 40;
    var y = sus + (H - PAD_JOS - sus - totalGrup) / 2;

    ctx.fillStyle = o.culoare;
    umbraText(ctx);
    if (o.data) {
      ctx.font = '600 ' + marimeData + 'px ' + o.font;
      y += marimeData;
      deseneazaTracked(ctx, o.data, W / 2, y, 0.01 * marimeData);
      y += gol;
    }
    if (randuriMesaj.length) {
      ctx.font = '400 ' + marimeMesaj + 'px ' + o.font;
      randuriMesaj.forEach(function (rand) {
        y += marimeMesaj * 1.6;
        ctx.fillText(rand, W / 2, y - marimeMesaj * 0.3);
      });
    }
    faraUmbra(ctx);
    ctx.restore();
  }

  /* O culoare pe care canvasul sigur o intelege: daca browserul nu o
     recunoaste, textul ar ramane umplut cu ce a fost inainte (gradientul
     valului), adica un text intunecat si aproape transparent. */
  function culoareSigura(c) {
    var proba = document.createElement('canvas').getContext('2d');
    if (!proba) return '#ffffff';
    proba.fillStyle = '#010203';
    proba.fillStyle = c;
    return proba.fillStyle === '#010203' && String(c).toLowerCase() !== '#010203' ? '#ffffff' : c;
  }

  /* Un cadru al secventei, la momentul t (ms). */
  function deseneazaScena(ctx, t, o) {
    /* Pornim fiecare cadru de la zero: fara umbre sau transparente ramase. */
    ctx.globalAlpha = 1;
    faraUmbra(ctx);
    deseneazaFundal(ctx, t, o.fundal);
    if (t < T_SLIDE_END) {
      deseneazaEcranApel(ctx, t, o);
    } else {
      deseneazaEcranInvitatie(ctx, t, o);
    }
  }

  /* ---- Exportul video ---------------------------------------------- */

  function genereazaVideo(o) {
    if (typeof MediaRecorder === 'undefined') {
      return Promise.reject(
        new Error('Browserul acesta nu știe să înregistreze video. Încearcă varianta cu filmatul ecranului.')
      );
    }
    /* mp4 DOAR cu H.264 cerut explicit: pe "video/mp4" simplu, Chrome poate
       baga VP9 in container, iar fisierul nu se mai deschide in Windows
       Media Player (eroarea 0xC00D36C4). Daca H.264 nu exista, e mai cinstit
       un webm adevarat decat un mp4 pe care jumatate din playere nu-l stiu. */
    var tipuri = [
      'video/mp4;codecs="avc1.42E01E"',
      'video/mp4;codecs=avc1',
      'video/webm;codecs=vp9',
      'video/webm'
    ];
    var tip = null;
    for (var i = 0; i < tipuri.length; i++) {
      if (MediaRecorder.isTypeSupported(tipuri[i])) {
        tip = tipuri[i];
        break;
      }
    }
    if (!tip) {
      return Promise.reject(
        new Error('Browserul acesta nu știe să înregistreze video. Încearcă varianta cu filmatul ecranului.')
      );
    }

    return document.fonts.ready.then(function () {
      o = {
        fundal: o.fundal,
        nume: o.nume,
        data: o.data,
        mesaj: o.mesaj,
        font: o.font,
        culoare: culoareSigura(o.culoare),
        scale: o.scale
      };
      var canvas = document.createElement('canvas');
      canvas.width = W;
      canvas.height = H;
      var ctx = canvas.getContext('2d');

      var stream = canvas.captureStream(30);
      var rec = new MediaRecorder(stream, { mimeType: tip, videoBitsPerSecond: 8000000 });
      var bucati = [];
      rec.ondataavailable = function (e) {
        if (e.data.size) bucati.push(e.data);
      };
      var oprit = new Promise(function (res) {
        rec.onstop = function () {
          res();
        };
      });

      deseneazaScena(ctx, 0, o);
      rec.start();

      /* Secventa se deseneaza in timp real: clipul dureaza cat il vezi.
         Cu setInterval, nu cu requestAnimationFrame: rAF ingheata cand
         pagina nu mai e vizibila, iar inregistrarea nu s-ar mai termina
         daca se schimba tabul intre timp. */
      return new Promise(function (res) {
        var start = performance.now();
        var cronometru = setInterval(function () {
          var t = performance.now() - start;
          deseneazaScena(ctx, Math.min(t, T_TOTAL), o);
          if (t >= T_TOTAL) {
            clearInterval(cronometru);
            res();
          }
        }, 1000 / 30);
      }).then(function () {
        rec.stop();
        return oprit.then(function () {
          return {
            blob: new Blob(bucati, { type: tip.split(';')[0] }),
            extensie: tip.indexOf('mp4') !== -1 ? 'mp4' : 'webm'
          };
        });
      });
    });
  }

  /* ---- Exportul GIF ------------------------------------------------- */

  function genereazaGif(o, peProgres) {
    if (!window.gifenc) {
      return Promise.reject(new Error('Nu s-a încărcat partea de GIF. Reîncarcă pagina și încearcă din nou.'));
    }
    return document.fonts.ready.then(function () {
      o = {
        fundal: o.fundal,
        nume: o.nume,
        data: o.data,
        mesaj: o.mesaj,
        font: o.font,
        culoare: culoareSigura(o.culoare),
        scale: o.scale
      };

      /* GIF-ul iese la jumatate de rezolutie si 12 cadre pe secunda: altfel
         fisierul creste enorm si nu-l mai poti pune nicaieri. */
      var scara = 0.5;
      var W2 = W * scara;
      var H2 = H * scara;
      var fps = 12;
      var pas = 1000 / fps;

      /* Cadrele de desenat. Cat timp e miscare (apelul, glisarea, aparitia
         invitatiei) mergem cadru cu cadru. Pentru cele 15 secunde in care
         invitatia sta pe loc ajunge UN singur cadru cu durata lunga, altfel
         GIF-ul ar creste de cateva ori degeaba. Doar un fundal GIF animat
         are nevoie de cadre pana la capat, ca sa se miste in continuare. */
      var pasi = [];
      var fundalAnimat = o.fundal && o.fundal.tip === 'gif';
      var cadreMiscarare = Math.ceil(((fundalAnimat ? T_TOTAL : T_FINAL_MISCARE) / 1000) * fps);
      for (var c = 0; c < cadreMiscarare; c++) pasi.push({ t: c * pas, delay: Math.round(pas) });
      if (!fundalAnimat) pasi.push({ t: T_TOTAL, delay: Math.round(T_TOTAL - (cadreMiscarare - 1) * pas) });

      var canvas = document.createElement('canvas');
      canvas.width = W2;
      canvas.height = H2;
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.setTransform(scara, 0, 0, scara, 0, 0);

      var enc = window.gifenc.GIFEncoder();
      var lant = Promise.resolve();
      for (var i = 0; i < pasi.length; i++) {
        (function (idx) {
          lant = lant.then(function () {
            deseneazaScena(ctx, pasi[idx].t, o);
            var date = ctx.getImageData(0, 0, W2, H2).data;
            var paleta = window.gifenc.quantize(date, 256);
            var indexat = window.gifenc.applyPalette(date, paleta);
            enc.writeFrame(indexat, W2, H2, { palette: paleta, delay: pasi[idx].delay });
            if (peProgres) peProgres(idx + 1, pasi.length);
            /* Din cand in cand lasam pagina sa respire, sa nu inghete butoanele. */
            if (idx % 6 === 5) {
              return new Promise(function (r) {
                setTimeout(r);
              });
            }
          });
        })(i);
      }
      return lant.then(function () {
        enc.finish();
        return new Blob([enc.bytes()], { type: 'image/gif' });
      });
    });
  }

  window.MiresicaApelClip = {
    pregatesteFundal: pregatesteFundal,
    genereazaVideo: genereazaVideo,
    genereazaGif: genereazaGif
  };
})();
